module.exports = __webpack_public_path__ + "img/banner.dfe708ea.png";